const LETTER = /\p{L}/u

/** Whether the text has at least one letter, in any alphabet. Add stays disabled until it does. */
export function containsLetter(text: string): boolean {
  return LETTER.test(text)
}
